import { defineComponent as s, computed as m, openBlock as n, createElementBlock as a, withDirectives as b, createElementVNode as d, isRef as r, vModelCheckbox as h, unref as x, toDisplayString as k, createCommentVNode as f } from "vue";
const v = { class: "ap-checkbox" }, C = ["id", "name", "value", "disabled"], V = ["for"], p = ["for"], y = /* @__PURE__ */ s({
  __name: "CheckBox",
  props: {
    id: null,
    name: null,
    label: null,
    value: null,
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: c }) {
    const u = e, l = m({
      get() {
        return u.modelValue;
      },
      set(t) {
        c("update:modelValue", t);
      }
    });
    return (t, o) => (n(), a("div", v, [
      b(d("input", {
        type: "checkbox",
        id: e.id,
        name: e.name,
        value: e.value,
        disabled: e.disabled,
        "onUpdate:modelValue": o[0] || (o[0] = (i) => r(l) ? l.value = i : null)
      }, null, 8, C), [
        [h, x(l)]
      ]),
      d("label", {
        class: "checkbox",
        for: e.id
      }, null, 8, V),
      e.label ? (n(), a("label", {
        key: 0,
        class: "text",
        for: e.id
      }, k(e.label), 9, p)) : f("", !0)
    ]));
  }
});
const g = {
  install: (e) => {
    e.component("ApCheckbox", y);
  }
};
export {
  y as ApCheckbox,
  g as default
};
